"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Lock } from "lucide-react";
import { PillToggle } from "@/components/ui/controls/PillToggle";
interface BadgeDefinition {
  id: string;
  label: string;
  description: string;
  assets?: {
    mainImageUrl?: string;
  } | null;
  enabled: boolean;
}
interface EarnedBadge {
  id: string;
  achievedAt: string;
}
interface BadgesShowcaseProps {
  badgeDefinitions: Record<string, BadgeDefinition[]>;
  earnedBadges: EarnedBadge[];
  labels: Record<string, string>;
}
const CATEGORY_LABEL_KEYS: Record<string, string> = {
  predictor: "categoryPredictor",
  games: "categoryGames",
  football: "categoryFootball",
  discussions: "categoryDiscussions",
  voting: "categoryVoting",
  topX: "categoryTopX",
  matchQuiz: "categoryMatchQuiz",
  classicQuizzes: "categoryClassicQuizzes",
  eitherOr: "categoryEitherOr"
};
function getCategoryLabel(category: string, labels: Record<string, string>): string {
  const key = CATEGORY_LABEL_KEYS[category];
  if (key && labels[key]) return labels[key];
  // Fallback: capitalize the category name
  return category.charAt(0).toUpperCase() + category.slice(1);
}
function formatDate(dateStr: string): string {
  try {
    return new Intl.DateTimeFormat(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric"
    }).format(new Date(dateStr));
  } catch {
    return dateStr;
  }
}
export default function BadgesShowcase(t0) {
  const $ = _c(18);
  const {
    badgeDefinitions,
    earnedBadges,
    labels
  } = t0;
  const categories = Object.keys(badgeDefinitions).filter(cat => badgeDefinitions[cat].length > 0);
  const [activeCategory, setActiveCategory] = useState(categories[0] ?? "");
  const earnedSet = new Map(earnedBadges.map(_temp));
  if (categories.length === 0) {
    let t1;
    if ($[0] !== labels.badges) {
      t1 = <h2 className="text-xl font-bold text-foreground">{labels.badges}</h2>;
      $[0] = labels.badges;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== labels.noBadges) {
      t2 = <p className="text-sm text-muted-foreground">{labels.noBadges}</p>;
      $[2] = labels.noBadges;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
      t3 = <div className="flex flex-col gap-4">{t1}{t2}</div>;
      $[4] = t1;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  const activeBadges = badgeDefinitions[activeCategory] ?? [];
  const t1 = "flex flex-col gap-4";
  let t2;
  if ($[7] !== labels.badges) {
    t2 = <h2 className="text-xl font-bold text-foreground">{labels.badges}</h2>;
    $[7] = labels.badges;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = categories.map(cat_0 => ({
    id: cat_0,
    label: getCategoryLabel(cat_0, labels)
  }));
  let t4;
  if ($[9] !== activeCategory || $[10] !== t3) {
    t4 = <PillToggle options={t3} activeId={activeCategory} onChange={setActiveCategory} size="md" />;
    $[9] = activeCategory;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = "grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4";
  const t6 = activeBadges.map(badge => {
    const earned = earnedSet.get(badge.id);
    const isEarned = !!earned;
    return <div key={badge.id} className={`relative flex flex-col items-center gap-2 rounded-lg bg-card p-3 ${isEarned ? "ring-1 ring-primary/20" : ""}`}><div className="relative">{badge.assets?.mainImageUrl ? <img src={badge.assets.mainImageUrl} alt={badge.label} className={`h-16 w-16 object-contain ${isEarned ? "" : "opacity-40 grayscale"}`} /> : <div className={`flex h-16 w-16 items-center justify-center rounded-full bg-muted text-2xl ${isEarned ? "" : "opacity-40 grayscale"}`}>🏅</div>}{!isEarned && <div className="absolute inset-0 flex items-center justify-center"><Lock className="h-6 w-6 text-muted-foreground" /></div>}</div><p className={`text-center text-sm font-medium ${isEarned ? "text-foreground" : "text-muted-foreground"}`}>{badge.label}</p><p className="text-center text-xs text-muted-foreground">{badge.description}</p>{isEarned && earned && <p className="text-xs text-primary">{formatDate(earned.achievedAt)}</p>}</div>;
  });
  let t7;
  if ($[12] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t2 || $[15] !== t4 || $[16] !== t7) {
    t8 = <div className={t1}>{t2}{t4}{t7}</div>;
    $[14] = t2;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
function _temp(b) {
  return [b.id, b];
}